import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.176,451.765 L112.942,451.765 L112.942,282.353 C112.942,251.181 138.353,225.882 169.412,225.882 L338.823,225.882 L338.823,282.353 C338.823,313.525 364.123,338.824 395.294,338.824 C426.466,338.824 451.765,313.525 451.765,282.353 L451.765,225.882 L1242.354,225.882 L1242.354,282.353 C1242.354,313.525 1267.654,338.824 1298.824,338.824 C1329.995,338.824 1355.294,313.525 1355.294,282.353 L1355.294,225.882 L1524.706,225.882 C1555.765,225.882 1581.176,251.181 1581.176,282.353 L1581.176,451.765 Z M1242.354,1242.351 L903.53,1242.351 L903.53,1581.177 L790.589,1581.177 L790.589,1242.351 L451.765,1242.351 L451.765,1129.412 L790.589,1129.412 L790.589,790.588 L903.53,790.588 L903.53,1129.412 L1242.354,1129.412 L1242.354,1242.351 Z M1524.706,112.941 L1355.294,112.941 L1355.294,56.471 C1355.294,25.299 1329.995,0 1298.824,0 C1267.654,0 1242.354,25.299 1242.354,56.471 L1242.354,112.941 L451.765,112.941 L451.765,56.471 C451.765,25.299 426.466,0 395.294,0 C364.123,0 338.823,25.299 338.823,56.471 L338.823,112.941 L169.412,112.941 C76.009,112.941 0,188.951 0,282.353 L0,1920 L1694.118,1920 L1694.118,282.353 C1694.118,188.951 1618.11,112.941 1524.706,112.941 L1524.706,112.941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "translate(113)"
});

var IconCalendarAddSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarAddSolid, _Component);

  var _super = _createSuper(IconCalendarAddSolid);

  function IconCalendarAddSolid() {
    _classCallCheck(this, IconCalendarAddSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarAddSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarAdd",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarAddSolid.displayName = "IconCalendarAddSolid";
  return IconCalendarAddSolid;
}(Component);

IconCalendarAddSolid.glyphName = 'calendar-add';
IconCalendarAddSolid.variant = 'Solid';
IconCalendarAddSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarAddSolid;
export { IconCalendarAddSolid };